export default "__VITE_ASSET__DiGBWoEj__"